import { KeycloakState } from './types';

/* eslint-disable no-alert, @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
const initialState: KeycloakState = {
  ready: (window as any).keycloakReadyDjango || false,
  authenticated: false,
  tokens: null,
};

export const keycloakReducer = (state: KeycloakState = initialState, action: any) => {
  switch (action.type) {
    case 'KEYCLOAK_STATE':
      const { idToken, refreshToken, token } = (window as any).keycloak;
      const ready = state.ready || !!(window as any).keycloakReadyDjango || action.payload.event === 'onReady';
      (window as any).keycloakReady = ready;
      return {
        ...state,
        ready,
        tokens: action.payload.tokens || state.tokens || { idToken, refreshToken, token },
        lastEvent: action.payload.event || state.lastEvent,
      };
    default:
      return state;
  }
};
